<template>
  <div class="prozess-wrapper">
    <div class="prozess">
      <div>
        <div v-if="!claimed">
          <TaskBlocker :assignee="data.assignee" />
        </div>

        <div v-if="!isLoading">
          <CustomerDetails
            v-if="customerData !== null"
            :data="customerData"
            title="Kundeninformationen"
          />

          <PortingInformation
            v-if="portingData !== null"
            :portingData="portingData"
            :currentProvider="currentProvider"
            :displayPhoneNumbers="true"
          />

          <PortingCancelationReasons
            v-if="portingData !== null"
            :cancellationRequest="cancellationRequest"
          />

          <div class="group">
            <div class="headinglabel">
              Rückmeldung OCS
            </div>
            <div>
              <v-textarea
                ref="memo"
                v-model="feedbackForOcs"
                class="input-field"
                auto-grow
                clearable
                clear-icon="mdi-delete"
                counter="250"
                :rules="[
                  (v) =>
                    v == null ||
                    v.length <= 250 ||
                    'Das Feedback darf maximal 250 Zeichen lang sein!'
                ]"
                name="feedbackForOcs-input"
                placeholder=""
                :value="feedbackForOcs"
                :disabled="!claimed"
                @input="validateInputs()"
              />
            </div>
          </div>
        </div>

        <div v-else>
          <Loader />
        </div>
      </div>

      <div v-if="!isLoading" class="buttons-wrapper">
        <v-btn
          color="secondary"
          large
          :disabled="validationErrors || !claimed"
          @click="completeTask(true)"
        >
          Portierung abbrechen
        </v-btn>
        <v-btn
          color="primary"
          large
          :disabled="validationErrors || !claimed"
          @click="completeTask(false)"
        >
          Portierung weiterführen
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP } from '@/main/httpClient.js';
import NotificationObject from '@/main/NotificationObject.js';

import CustomerDetails from '@/components/CustomerDetails.vue';
import PortingInformation from './PortingInformation.vue';
import PortingCancelationReasons from './PortingCancelationReasons.vue';

import NormalButton from '@/components/elements/NormalButton.vue';
import Loader from '@/components/elements/Loader.vue';
import TaskBlocker from '../TaskBlocker.vue';
import GoetelInput from '@/components/elements/GoetelInput.vue';
import ErrorMessageBuilder from '@/util/ErrorMessageBuilder.js';

export default {
  name: 'ActionCancelPortingProcess',
  components: {
    NormalButton,
    TaskBlocker,
    CustomerDetails,
    PortingInformation,
    PortingCancelationReasons,
    Loader,
    GoetelInput
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    portingData: null,
    customerData: null,
    cancellationRequest: null,
    feedbackForOcs: '',
    validationErrors: false,
    currentProvider: null
  }),
  computed: {
    username() {
      return this.$store.getters.getUsername;
    },
    claimed() {
      return this.data.assignee === this.username;
    }
  },
  mounted: function () {
    this.loadTaskData(this.data.id);
  },
  methods: {
    validateInputs() {
      if (this.$refs && this.$refs.memo) {
        this.validationErrors = !this.$refs.memo.validate(true);
      } else {
        this.validationErrors = false;
      }
    },
    showMessage: function (type, description) {
      this.$store.commit(
        'addNotification',
        new NotificationObject(type, description)
      );
    },
    loadTaskData: function (id) {
      this.isLoading = true;
      HTTP.get(`/task/${id}/variables`)
        .then((resp) => {
          this.portingData = resp.data.porting.value;
          this.currentProvider = resp.data.currentProvider.value;
          this.contractId = this.portingData.contractId;
          this.customerData = resp.data.customer.value;
          this.cancellationRequest = resp.data.cancelationRequest.value;
        })
        .catch(() => {
          this.showMessage(
            'error',
            'Die Daten konnten nicht vollständig geladen werden!'
          );
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    completeTask: function (cancellationRequestApproved) {
      HTTP.post(`/portingTask/cancelPortingResult/${this.data.id}`, {
        cancellationRequestApproved: cancellationRequestApproved,
        feedbackForOcs: this.feedbackForOcs
      })
        .then((resp) => {
          const message = cancellationRequestApproved
            ? 'Der Portierungsprozess wurde beendet.'
            : 'Der Portierungsprozess wird wieder weitergeführt.';
          this.showMessage('info', message);
          this.$store.commit('triggerTasksRefresh');
          this.$emit('onClose');
        })
        .catch((err) =>
          this.showMessage(
            'error',
            ErrorMessageBuilder.buildErrorMessage(
              err.response.data,
              'Der Abschluss der Aufgabe war nicht erfolgreich!'
            )
          )
        );
    }
  }
};
</script>

<style scoped>
.buttons-wrapper {
  display: grid;
  grid-template-columns: auto max-content;
  grid-gap: var(--goe-spacing-1);
}

.buttons-wrapper .v-btn {
  width: max-content;
  margin-left: auto;
  margin-right: var(--goe-spacing-0);
}

.loader {
  margin: auto;
}

.description {
  font-size: var(--goe-fontSize-small);
  margin-top: var(--goe-spacing-0_5);
}

.group > div:nth-child(2) > div {
  margin-bottom: var(--goe-spacing-2);
}

.group > div:nth-child(2) > div:last-child {
  margin-bottom: var(--goe-spacing-0);
}

.input-field {
  background: var(--goe-background-highlight);
}

select {
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  border: none;
  width: calc(100% - 4px);
  min-height: var(--goe-spacing-3);
  -moz-padding-start: calc(10px - 3px);
  padding-left: 10px;
  padding-top: 5px;
}

option:first-child {
  display: none;
}

.headinglabel {
  color: var(--goe-fontColor-highlight);
  font-size: var(--goe-fontSize-normal);
}
</style>
